"use strict";
import FactorBrokersStore from "../stores/factor_brokers_store";
var FactorBrokersService = function() {
  var store = FactorBrokersStore;
  this.getWithId = function(id) {
    var existing = store.index[id];
    if (id) {
      if (existing) {
        return Promise.resolve(store.index[id]);
      } else {
        return this.fetchWithID(id);
      }
    } else {
      return Promise.resolve(null);
    }
  };
  this.getFetchedWithId = (id) => store.index[id];
  this.fetchWithID = function(id) {
    return Promise.resolve().then(function() {
      return $.get("/api/factor_brokers/" + id).then(function(data) {
        FactorBrokersStore.addOrUpdate(data.factor_broker);
        return store.index[id];
      });
    });
  };
  this.search = function(term, silo) {
    return $.get("/api/factor_brokers", { page: 1, term, silo }).then(function(data) {
      return data.factor_brokers;
    }, _.identity());
  };
};
var factorBrokersService = new FactorBrokersService();
export default factorBrokersService;
